/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Tally1 = ["svg", defaultAttributes, [["path", { d: "M4 4v16" }]]];

export { Tally1 as default };
//# sourceMappingURL=tally-1.js.map
